<template lang="html">
  <v-container>
    <v-row>
      <setup-training-training-sessions-dialog-create
        v-if="$hasPermissionTo(['create training sessions'])"
        :course-id="courseId"
        @created="loadData"
      /> 
    </v-row>

    <v-data-table
      :headers="headers"
      :items="trainingSessions"
      :single-expand="true"
      item-key="id"
      show-expand
      hide-default-footer
      fixed-header
      disable-pagination
      class="datatable-scrollbar"
    >
      <template v-slot:item="props">
        <tr>
          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <v-btn
              icon
              @click="props.expand(!props.isExpanded)"
            >
              <v-icon small> 
                {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
              </v-icon>
            </v-btn>
          </td>
          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            {{ props.item.name }}
          </td>
          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            {{ props.item.instructor_name }}
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            {{ $moment(props.item.date).format('DD-MM-YYYY') }}
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            {{ props.item.venue }}
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            {{ props.item.time }}
          </td>

          <td
            :class="props.isExpanded? 'remove-bottom-border align-center':'border-bottom align-center' "
          > 
            {{ props.item.participants.length }}
          </td>

          <td
            :class="props.isExpanded? 'remove-bottom-border align-center':'border-bottom align-center' "
          > 
            {{ props.item.moderator.person.name }}
          </td>

          <td 
            :class="props.isExpanded? 'remove-bottom-border align-center':'border-bottom align-center' "
          >
            <setup-training-training-participants-container-view
              :session="props.item"
              @updated="loadData"
            />
            <setup-training-training-sessions-dialog-edit
              v-if="$hasPermissionTo(['update training sessions'])"
              :session="props.item"
              @updated="loadData"
            />
            <setup-training-training-sessions-dialog-delete
              v-if="$hasPermissionTo(['delete training sessions'])"
              :session="props.item"
              @deleted="loadData"
            />
          </td>
        </tr>
      </template>

      <template
        v-slot:expanded-item="{ headers, item }"
      >    
        <td
          class="description"
          :colspan="12"
        >
          <div>
            {{ item.description }}
          </div>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupTrainingTrainingSessionsDialogEdit: () => import('@/components/setup/training/training-sessions/DialogEdit'),
      SetupTrainingTrainingSessionsDialogDelete: () => import('@/components/setup/training/training-sessions/DialogDelete'),
      SetupTrainingTrainingSessionsDialogCreate: () => import('@/components/setup/training/training-sessions/DialogCreate'),
      SetupTrainingTrainingParticipantsContainerView: () => import('@/components/setup/training/training-participants/ContainerView'),
    },
    inject: ['$validator'],
    props: {
      courseId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        headers: [
          { text: '', value: 'data-table-expand' },
          { text: 'Name', value: 'name', align: 'left' },
          { text: 'Instructor', value: 'instructor_name', align: 'left' },
          { text: 'Training Date', sortable: false, value: 'date' },
          { text: 'Venue', sortable: false, value: 'venue' },
          { text: 'Time', sortable: false, value: 'time' },
          { text: 'No of Participants', sortable: false, align: 'center', value: 'participants.length' },
          { text: 'Moderator', sortable: false, align: 'center', value: 'moderator' },
          { text: 'Actions', sortable: false, value: 'action', align: 'center' },
         
        ],

        expanded: [],

        progressing: false,
        edit: false,
        loading: false,
        trainingSessions: [],
      }
    },

    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.loadTrainingSessions()
      },

      loadTrainingSessions () {
        this.$api.trainingSessions().show(this.courseId)
          .then(res => {
            if (res.status === 200) {
              this.trainingSessions = res.data
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },

    },
  }
</script>

<style scoped>
.description {
    padding-left:85px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.align-center {
    text-align:center
}

.remove-bottom-border {
    border-bottom: 0px !important
}

.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}

.datatable-scrollbar{
  height: 435px;
  overflow-y: auto;
}

.datatable-scrollbar::-webkit-scrollbar {
  width: 3px !important; 
}

/* Track */
.datatable-scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
.datatable-scrollbar::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
.datatable-scrollbar::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}

</style>
